(function () {
  'use strict';
  var HT = window.PETIDI_T || {};
  function ht(k, d, o) { var s = HT[k] || d; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('MobileDrawer');
  var drawerOpen = document.getElementById('DrawerOpen');
  if (drawer && drawerOpen) {
    var openDrawer = function () { drawer.classList.add('is-open'); drawerOpen.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; };
    var closeDrawer = function () { drawer.classList.remove('is-open'); drawerOpen.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
    drawerOpen.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
  }

  /* Mobilde "kaydırınca arama satırını gizle" (is-collapsed) KALDIRILDI (CLS):
     header akış içinde ve yapışmıyor (section kabuğu kendi boyunda), 60px'te
     arama satırı (~58px) display:none olunca altındaki TÜM sayfa yukarı
     zıplıyordu — Search Console mobil CLS > 0,1 uyarısının ana kaynağı. */

  /* ---------- Yukarı kaydırınca gelen başlık (Baymard 2. tur #26, 17 Eki 2026) ----------
     Header ayarı "yapışsın" açıkken, koleksiyon + arama DIŞINDAKİ sayfalarda (orada mobil başlığın kayıp gitmesi kullanıcı
     kararı): başlık ekrandan çıkınca position:fixed + translateY(-105%) ile gizli bekler, yukarı kaydırınca kayarak gelir,
     aşağı kaydırınca gider. Bölüm kabuğu açılışta başlık yüksekliğinde tutulur → fixed'e geçmek akışı oynatmaz (CLS yok);
     yalnız transform değişir. Mobilde ince: arama satırı yerine arama ikonu. En üste dönünce akıştaki yerine aynı konumda döner. */
  (function () {
    var hdr = document.getElementById('SiteHeader');
    if (!hdr || hdr.getAttribute('data-sticky') !== 'true') return;
    if (/\btemplate-(collection|search)\b/.test(document.body.className)) return;
    var kabuk = hdr.parentElement;
    var kok = document.documentElement;
    var h = 0, sonY = window.scrollY, yapis = false, gorunur = false, bekliyor = false;
    function olc() {
      if (yapis) return;
      kabuk.style.minHeight = '';
      h = hdr.offsetHeight;
      kabuk.style.minHeight = h + 'px';
    }
    function goster(ac) {
      if (ac === gorunur) return;
      gorunur = ac;
      hdr.classList.toggle('is-gorunur', ac);
      kok.style.setProperty('--hdr-ust', ac ? hdr.offsetHeight + 'px' : '0px');
    }
    function guncelle() {
      bekliyor = false;
      var y = window.scrollY, dy = y - sonY;
      if (y <= 0) {
        if (yapis) { goster(false); hdr.style.transition = 'none'; hdr.classList.remove('is-yapis'); void hdr.offsetHeight; hdr.style.transition = ''; yapis = false; }
      } else if (!yapis && y > h + 40) {
        hdr.style.transition = 'none'; hdr.classList.add('is-yapis'); void hdr.offsetHeight; hdr.style.transition = '';
        yapis = true;
      } else if (yapis) {
        if (y < h) goster(true);                 // akıştaki yeri ekrandayken boş kalmasın
        else if (dy < -4) goster(true);
        else if (dy > 4) goster(false);
      }
      sonY = y;
    }
    olc();
    window.addEventListener('resize', olc);
    window.addEventListener('load', olc);
    window.addEventListener('scroll', function () { if (!bekliyor) { bekliyor = true; requestAnimationFrame(guncelle); } }, { passive: true });
  })();

  /* ---------- Search overlay ---------- */
  var overlay = document.getElementById('SearchOverlay');
  var input = document.getElementById('PredictiveInput');
  var results = document.getElementById('PredictiveResults');
  var clearBtn = document.getElementById('PredictiveClear');
  var defaultHTML = results ? results.innerHTML : '';

  var openOverlay = function () {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Arama sayfasında sorgu başlık kutusunda duruyor (Baymard #25): pencere aynı sorguyla, seçili açılır
    var tetik = document.querySelector('[data-search-trigger]');
    if (input && !input.value && tetik && tetik.value) {
      input.value = tetik.value;
      input.dispatchEvent(new Event('input'));
    }
    setTimeout(function () { if (input) { input.focus(); input.select(); } }, 50);
  };
  var closeOverlay = function () {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (input) input.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
    if (results) results.innerHTML = defaultHTML;
  };

  document.querySelectorAll('[data-search-trigger], #SearchIconBtn').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openOverlay(); });
  });
  document.querySelectorAll('[data-search-open]').forEach(function (form) {
    form.addEventListener('click', function (e) { e.preventDefault(); openOverlay(); });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', closeOverlay);
  });

  /* ---------- Predictive search (Shopify API) ---------- */
  var debounceTimer;
  var searchAbort;
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };

  // Baymard 2. tur #23 (17 Eki 2026): başlık "Öneriler"; kategori/marka koleksiyonları (en fazla 3); çok boylu üründe "…'den";
  // en altta "“sorgu” için tüm sonuçlar →" (Enter'ı bilmeyen için çıkış).
  var tl = function (n) { return n.toLocaleString('tr-TR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  var ok = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
  /* ---------- Alaka kontrolü: "bunu satıyor muyuz?" (18 Eki 2026) ----------
     snippets/arama-alaka.liquid ile AYNI kural (değiştirirsen ikisini birlikte değiştir). Sorgunun ayırt edici kelimeleri
     (genel kelime/sayı/birim/tek harf atılır) önerilen ürünlerin başlık/tür/marka/etiketinde (açıklamada yalnız 4+ harfli
     tam kelime) hiç eşleşmezse "satılmıyor":
     alakasız ürünler yerine "Bunu şu an satmıyoruz" + hızlı bağlantılar. Eşleşme: aynı kelime, 4+ harfte kelime başı,
     Türkçe ek atılmış kök, bitişik yazım (proplan), 1 harf yazım hatası (5+ harf; 4 harfte yalnız yer değiştirme).
     Yazılmakta olan son kelime (sonda boşluk yok) kelime başı olarak eşleşir; 4 harften kısaysa tek başına karar verdirmez. */
  var ALAKA_GENEL = ' kedi kediler kedisi kedim kediye kedinin kedilere kedicik kopek kopegi kopekler kopegim kopege kopegin kopeklere mama mamasi mamalari mamalar icin ve ile veya yavru yavrusu yetiskin kg gr g kilo gram lt ml adet paket en iyi ucuz fiyat fiyati fiyatlari urun urunleri urunler petidi satin al kuru yas evcil hayvan hayvanlar pet li lu lik luk de da mi mu ';
  var ALAKA_BIRIM = ' kg gr g lt ml li lu lik luk x ';
  var ALAKA_EKLER = ['lari', 'leri', 'lar', 'ler', 'si', 'su', 'in', 'un', 'nin', 'nun', 'u', 'i'];
  var alakaNorm = function (s) {
    s = String(s || '').replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase().replace(/i̇/g, 'i');
    var m = { 'ı': 'i', 'ş': 's', 'ğ': 'g', 'ü': 'u', 'ö': 'o', 'ç': 'c', 'â': 'a', 'î': 'i', 'û': 'u', 'é': 'e', 'è': 'e', 'ë': 'e', 'ä': 'a' };
    s = s.replace(/[ışğüöçâîûéèëä]/g, function (c) { return m[c]; });
    return s.replace(/['’.,\-_/()&+!?:;"%*#|\[\]<>=“”–—\s]+/g, ' ').trim();
  };
  var tekHata = function (t, w) {
    var fark = Math.abs(w.length - t.length), i;
    if (fark > 1 || (fark === 1 && t.length < 5)) return false;
    if (fark === 0) {
      var d = [];
      for (i = 0; i < t.length && d.length < 3; i++) if (t[i] !== w[i]) d.push(i);
      if (d.length === 1 && t.length >= 5) return true;
      return d.length === 2 && d[1] === d[0] + 1 && t[d[0]] === w[d[1]] && t[d[1]] === w[d[0]];
    }
    var uzun = w.length > t.length ? w : t, kisa = w.length > t.length ? t : w, ilk = kisa.length;
    for (i = 0; i < kisa.length; i++) if (uzun[i] !== kisa[i]) { ilk = i; break; }
    return uzun.slice(0, ilk) + uzun.slice(ilk + 1) === kisa;
  };
  // urunler: [{title, type, vendor, tags}] · dönüş: { satilmiyor: bool, terimler: [] }
  var alakaKontrol = function (sorgu, urunler, yaziliyor) {
    var kel = alakaNorm(sorgu).split(' '), ayirt = [], sonYazilan = null;
    kel.forEach(function (t, i) {
      if (t.length < 2 || ALAKA_GENEL.indexOf(' ' + t + ' ') >= 0) return;
      var tn = t.replace(/[0-9]/g, '');
      if (tn.length < t.length && (tn === '' || ALAKA_BIRIM.indexOf(' ' + tn + ' ') >= 0)) return;
      if (ayirt.indexOf(t) >= 0) return;
      ayirt.push(t);
      if (yaziliyor && i === kel.length - 1) sonYazilan = t;
    });
    if (!ayirt.length) return { satilmiyor: false, terimler: [] };
    var ham = [], bit = [], acik = [];
    (urunler || []).forEach(function (p) {
      ham.push(p.title, p.type || p.product_type || '', p.vendor || '', (p.tags || []).join(' '));
      acik.push(String(p.body || p.body_html || '').replace(/<[^>]*>/g, ' '));
      var tw = alakaNorm(p.title).split(' ');
      for (var j = 1; j < tw.length; j++) bit.push(tw[j - 1] + tw[j]);
    });
    var hn = alakaNorm(ham.join(' '));
    var kelimeler = hn ? hn.split(' ') : [];
    var saman = ' ' + hn + ' ' + bit.join(' ') + ' ';
    var aciklama = ' ' + alakaNorm(acik.join(' ')) + ' ';
    // Açıklama yalnız 4+ harfli tam kelimeyle ("böbrek", "tüy yumağı")
    var var_ = function (c, bas) { return saman.indexOf(' ' + c + ' ') >= 0 || (bas && saman.indexOf(' ' + c) >= 0) || (c.length >= 4 && aciklama.indexOf(' ' + c + ' ') >= 0); };
    var eslesen = 0, belirsiz = false;
    ayirt.forEach(function (t) {
      var ok = false;
      if (t === sonYazilan) {
        ok = saman.indexOf(' ' + t) >= 0;
        if (!ok && t.length < 4) belirsiz = true;
      }
      if (!ok) ok = var_(t, t.length >= 4);
      if (!ok) ALAKA_EKLER.some(function (e) {
        var kalan = t.length - e.length;
        if (kalan < 3 || t.slice(kalan) !== e) return false;
        var kok = t.slice(0, kalan);
        return (ok = var_(kok, kok.length >= 4));
      });
      if (!ok && t.length >= 4) ok = kelimeler.some(function (w) { return tekHata(t, w); });
      if (ok) eslesen++;
    });
    // Tek ayırt edici kelime henüz yazılıyor ve kısa ("wh", "tas"): karar verme
    if (!eslesen && belirsiz && ayirt.length === 1) return { satilmiyor: false, terimler: ayirt };
    return { satilmiyor: eslesen === 0, terimler: ayirt };
  };
  window.PetidiAlaka = alakaKontrol;   // test için (tarayıcı konsolu / Playwright)

  // Satılmayan aramayı ziyaretçi akışına bildir (ziyaretci.js dinler; izin yoksa o gönderMEZ). Yazmayı bırakınca bir kez.
  var bildirilen = {}, bildirZaman;
  var satilmiyorBildir = function (q) {
    clearTimeout(bildirZaman);
    bildirZaman = setTimeout(function () {
      var k = alakaNorm(q);
      if (!k || bildirilen[k]) return;
      bildirilen[k] = 1;
      try { document.dispatchEvent(new CustomEvent('petidi:arama-satilmiyor', { detail: { q: q, k: 'oneri' } })); } catch (e) {}
    }, 1500);
  };

  var renderResults = function (data, query) {
    var html = '';
    var p = data.resources.results;
    var var_ = false;

    if (p.queries && p.queries.length) {
      var_ = true;
      html += '<div class="predictive__heading">' + ht('ara_oneriler', 'Öneriler') + '</div>';
      p.queries.slice(0, 5).forEach(function (q) {
        html += '<a href="' + q.url + '" class="predictive__suggest"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><span>' + q.styled_text + '</span></a>';
      });
    }

    if (p.collections && p.collections.length) {
      var_ = true;
      html += '<div class="predictive__heading">' + ht('ara_kategoriler', 'Kategoriler ve markalar') + '</div>';
      p.collections.slice(0, 3).forEach(function (c) {
        html += '<a href="' + c.url + '" class="predictive__suggest predictive__kol"><span>' + esc(c.title) + '</span>' + ok + '</a>';
      });
    }

    var alaka = alakaKontrol(query, p.products, !/\s$/.test(input ? input.value : ''));
    if (input) input.toggleAttribute('data-satilmiyor', alaka.satilmiyor);
    if (alaka.satilmiyor) {
      satilmiyorBildir(query);
      var tumuUrl = (window.PETIDI_KOK || '') + '/search?q=' + encodeURIComponent(query) + '&type=product';
      results.innerHTML = '<div class="predictive__satmiyoruz"><p class="predictive__satmiyoruz-bas">' + ht('ara_bulunamadi', '“[q]” bulunamadı', { q: esc(query) }) + '</p>' +
        '<p>' + ht('ara_satmiyoruz', 'Bunu şu an satmıyoruz. Aşağıdakilere göz atabilir ya da size uygun mamayı bulabilirsiniz.') + '</p></div>' +
        '<button type="button" class="predictive__suggest predictive__kol predictive__quiz" data-quiz-open><span>' + ht('ara_quiz', '<b>Hangi mama uygun?</b> 1 dakikalık testle bul') + '</span>' + ok + '</button>' +
        defaultHTML +
        ((p.products && p.products.length) ? '<a class="predictive__tumu predictive__tumu--ikincil" href="' + tumuUrl + '">' + ht('ara_yine_de', 'Yine de ilgili ürünleri gör') + ok + '</a>' : '');
      return;
    }

    if (p.products && p.products.length) {
      var_ = true;
      html += '<div class="predictive__heading">' + ht('ara_urunler', 'Ürünler') + '</div>';
      p.products.slice(0, 6).forEach(function (prod) {
        var img = prod.featured_image ? prod.featured_image.url : '';
        // suggest.json fiyatı TL olarak döner ("239.00"), kuruş değil. Kampanya (sepette indirim) fiyatı burada yok.
        var min = Number(prod.price_min || prod.price), max = Number(prod.price_max || prod.price);
        var price = min ? (max > min ? ht('ara_fiyat_den', '[f]\'den', { f: tl(min) + ' TL' }) : tl(min) + ' TL') : '';
        html += '<a href="' + prod.url + '" class="predictive__product">' +
          (img ? '<img class="predictive__product-img" src="' + img + '" alt="" loading="lazy">' : '<div class="predictive__product-img"></div>') +
          '<div><div class="predictive__product-name">' + esc(prod.title) + '</div><div class="predictive__product-price">' + price + '</div></div></a>';
      });
    }

    if (!var_) {
      html = '<div class="predictive__empty">' + ht('ara_oneri_yok', '"[q]" için öneri bulunamadı. Enter\'a basarak tüm sitede arayabilirsiniz.', { q: esc(query) }) + '</div>';
    }
    html += '<a class="predictive__tumu" href="' + (window.PETIDI_KOK || '') + '/search?q=' + encodeURIComponent(query) + '">' + ht('ara_tum_sonuclar', '“[q]” için tüm sonuçlar', { q: esc(query) }) + ok + '</a>';

    results.innerHTML = html;
  };

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.style.display = q ? 'inline-flex' : 'none';
      clearTimeout(debounceTimer);

      if (q === '') { results.innerHTML = defaultHTML; return; }

      debounceTimer = setTimeout(function () {
        var url = (window.PETIDI_KOK || '') + '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        if (searchAbort) searchAbort.abort();
        searchAbort = new AbortController();
        fetch(url, { signal: searchAbort.signal })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (data) { renderResults(data, q); })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            results.innerHTML = '<div class="predictive__empty">' + ht('ara_yuklenemedi', 'Öneriler yüklenemedi.') + '</div>' +
              '<a class="predictive__tumu" href="' + (window.PETIDI_KOK || '') + '/search?q=' + encodeURIComponent(q) + '">' + ht('ara_tum_sonuclar', '“[q]” için tüm sonuçlar', { q: esc(q) }) + ok + '</a>';
          });
      }, 200);
    });
  }

  // "Hangi mama uygun?" (satılmıyor görünümü): testi pet-quiz.js açar (belge dinleyicisi; ilk seferde dosyayı yükleyip
  // düğmeye yeniden tıklar). Düğme DOM'da kalmalı → içerik silinmeden yalnız pencere gizlenir.
  if (results) results.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-quiz-open]') && overlay) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.style.display = 'none';
      results.innerHTML = defaultHTML;
      input.focus();
    });
  }

  /* ---------- Mobile multi-level submenu ---------- */
  var subData = {};
  var dataEl = document.getElementById('DrawerMenuData');
  if (dataEl) {
    try {
      var parsed = JSON.parse(dataEl.textContent);
      (parsed.items || []).forEach(function (it) { subData[it.id] = it; });
    } catch (e) { console.warn('DrawerMenuData JSON parse error:', e); }
  }
  var subTitle = document.getElementById('DrawerSubTitle');
  var subListEl = document.getElementById('DrawerSubList');

  document.querySelectorAll('[data-open-sub]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-open-sub');
      var item = subData[id];
      if (!item || !drawer) return;
      subTitle.textContent = item.title;
      var ok = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      // 3 seviyeli menü: "grup" başlığı (bağlantı + Tümü), "alt" o grubun öğeleri (13 Eki 2026)
      subListEl.innerHTML = item.children.filter(Boolean).map(function (c) {
        if (c.grup) {
          return '<a href="' + c.url + '" class="menu-grup"><span>' + (c.title || '') + '</span><span class="menu-grup__tumu">' + ht('tumu', 'Tümü') + ok + '</span></a>';
        }
        return '<a href="' + c.url + '" class="menu-row' + (c.alt ? ' menu-row--alt' : '') + '"><span class="menu-row__left"><span class="menu-row__label">' +
          (c.title || '') + '</span></span><span class="menu-row__arrow">' + ok + '</span></a>';
      }).join('');
      drawer.classList.add('show-sub');
    });
  });
  document.querySelectorAll('[data-sub-back]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (drawer) drawer.classList.remove('show-sub'); });
  });
  // drawer kapanınca alt paneli sıfırla
  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { drawer.classList.remove('show-sub'); });
    });
  }
})();
